import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {createChannel, deleteChannel, fetchChannelById, updateChannel} from "../../services/Api/ChannelApi";
import {fetchPlatforms} from "../../services/Api/PlatformApi";

export const ChannelForm = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [currentChannel, setCurrentChannel] = useState({
        platform: '',
        name: '',
        urlStream: '',
        urlPolling: '',
        keyStream: ''
    });
    const [platforms, setPlatforms] = useState([]);

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setCurrentChannel({...currentChannel, [name]: value});
    };

    const addChannel = async () => {
        await createChannel(currentChannel);
        navigate(`/channels`);
    };

    const removeChannel = async () => {
        const confirmed = window.confirm("Êtes-vous sûr ?");
        if (confirmed) {
            await deleteChannel(id);
            navigate(`/channels`);
        }
    };

    const editChannel = async (currentChannel) => {
        await updateChannel(id, currentChannel);
        navigate(`/channels`);
    };

    const fetchChannel = async (id) => {
        const data = await fetchChannelById(id);
        setCurrentChannel(data);
    };

    const fetchAllPlatforms = async () => {
        const platforms = await fetchPlatforms();
        setPlatforms(platforms);
    };

    useEffect(() => {
        fetchAllPlatforms();
        if (id !== undefined) {
            fetchChannel(id);
        } else {
            setCurrentChannel({
                platform: '',
                name: '',
                urlStream: '',
                urlPolling: '',
                keyStream: ''
            });
        }
    }, [id]);

    return (
        <div>
            <h2>Formulaire de chaîne</h2>
            <div className="row mb-3">
                <label className="col-sm-2 col-form-label" htmlFor="platform">Plateforme</label>
                <div className="col-sm-10">
                    <select
                        className="form-control"
                        name="platform"
                        value={currentChannel.platform._id}
                        onChange={handleInputChange}
                    >
                        <option value="">Sélectionnez une plateforme</option>
                        {platforms.map((platform) => (
                            <option key={platform._id} value={platform._id}>
                                {platform.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="row mb-3">
                <label className="col-sm-2 col-form-label" htmlFor="name">Nom de la chaîne</label>
                <div className="col-sm-10">
                    <input
                        className="form-control"
                        type="text"
                        name="name"
                        value={currentChannel.name}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="row mb-3">
                <label className="col-sm-2 col-form-label" htmlFor="urlStream">URL du flux</label>
                <div className="col-sm-10">
                    <input
                        className="form-control"
                        type="url"
                        name="urlStream"
                        value={currentChannel.urlStream}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="row mb-3">
                <label className="col-sm-2 col-form-label" htmlFor="urlPolling">URL de polling</label>
                <div className="col-sm-10">
                    <input
                        className="form-control"
                        type="url"
                        name="urlPolling"
                        value={currentChannel.urlPolling}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="row mb-3">
                <label className="col-sm-2 col-form-label" htmlFor="keyStream">Clé de stream</label>
                <div className="col-sm-10">
                    <input
                        className="form-control"
                        type="text"
                        name="keyStream"
                        value={currentChannel.keyStream}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-end">
                <div className="btn-group" role="group">
                    <button
                        className="btn btn-success"
                        onClick={() => id ? editChannel(currentChannel) : addChannel()}
                    >
                        Valider
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={removeChannel}
                        disabled={!currentChannel._id}
                    >
                        Supprimer
                    </button>
                </div>
            </div>
        </div>
    );
};
